import { render, staticRenderFns } from "./Boxed.vue?vue&type=template&id=6622c5ea&scoped=true"
import script from "./Boxed.vue?vue&type=script&lang=js"
export * from "./Boxed.vue?vue&type=script&lang=js"
import style0 from "./Boxed.vue?vue&type=style&index=0&id=6622c5ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6622c5ea",
  null
  
)

export default component.exports